import { useDeposit } from '@/providers/DepositProvider';
import { useLingui } from '@lingui/react';
import { Box, Image, Paper, Stack, Text } from '@mantine/core';
import { BackButton } from '../BackButton';
import { PaySelect } from '../PaySelect';
import { DepositBanks } from './DepositBanks';
import { DepositBuyCryptoModal } from './DepositBuyCryptoModal';
export const DepositPayCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setActiveTab
  } = useDeposit();
  return <Stack mt={{
    base: 30,
    sm: 52,
    md: 33
  }}>
      <BackButton handleClick={() => setActiveTab('USDT')} />

      <Paper bg="var(--input-variant-color)" radius={5} p={{
      base: 10,
      sm: 20
    }} pos="relative">
        <Box w={589} style={{
        wordBreak: 'break-word'
      }} visibleFrom="lg">
          <Text fz={13} c="var(--text-dark)">
            {i18n._('While we look for a reliable card payment processor, you can purchase crypto using your card via the recommended third-party services below. After purchasing the crypto, you can deposit it directly to your Prime Roll account.')}
          </Text>
        </Box>

        <Box w={{
        base: 273,
        sm: 500
      }} style={{
        wordBreak: 'break-word'
      }} hiddenFrom="lg">
          <Text fz={{
          base: 10,
          sm: 13
        }} c="var(--text-dark)">
            {i18n._('*You will receive the specified Tether amount on your withdrawal address.')}
          </Text>
          <Text fz={{
          base: 10,
          sm: 13
        }} c="var(--text-dark)">
            {i18n._('*The value subtracted from your balance may vary between now and the time we process your withdrawal.')}
          </Text>
        </Box>

        <Image src="/assets/wallet/paycard.svg" alt="decoration" pos="absolute" w={{
        base: 80,
        sm: 178
      }} h={{
        base: 80,
        sm: 174
      }} bottom={{
        base: 10,
        sm: -10
      }} right={0} />
      </Paper>

      <Paper bg="var(--bg-600)" radius={5} p={{
      base: 10,
      sm: 20
    }}>
        <PaySelect />
        <Text fz={{
        base: 10,
        sm: 13
      }} c="var(--icon-color)" mt={25}>
          {i18n._('Disclaimer: The below third party services can be used to purchase crypto that can be used to play on Prime Roll. By registering on their platform, you are also accepting to their terms of service and will be required to pass their KYC process, which runs independently to ours.')}
        </Text>
      </Paper>

      <DepositBanks />

      <DepositBuyCryptoModal />
    </Stack>;
};